export default __webpack_public_path__ + "static/media/rolling.e1a3894a.svg";